// extracted by css-extract-rspack-plugin
export default {"RulesetFilterButtonText":"RulesetFilter-module__RulesetFilterButtonText__DvYAVSh"};